<template>
	<div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('assetTypeCreate') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ $t('assetTypeCreate') }}</li>
            </ol>
        </nav>
        <div class="row">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="name" required>{{ $t('name') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name" >
            </div>
              <div class="mb-3 col-md-8">
                <label class="form-label" for="description" required>{{ $t('description') }}</label>
                <input v-model="data.description" type="text" class="form-control" id="description">
            </div>
        </div>
        <div class="d-grid gap-2 d-md-flex ">
            <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('create') }}</button>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}` })">{{ $t('back') }}</button>
        </div>
    </div>

</template>

<script>
import AssetTypeApi from "../../api/server/assetType";
import ModelingApi from "../../api/server/modeling";

export default {
    name: "assettypecreate",
    watch: {
        $route: "requestData",
    },
    notifications: {
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.pending = true;

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;

            this.pending = false;
        },
        async onSubmit() {
            if(this.data.name.length > 0) {
                this.data.datasetId = this.$route.params.datasetId;
                this.data.visualizationValue = "performance";
                var assetType = await AssetTypeApi.assetTypeCreate(this.$route.params.id, this.data);
                this.$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${assetType.id}` })
            } else {
                this.showEmptyNameError();
            }
        }
    },
    data() {
        return {
            data: {
                name: "",
                visualizationValue: "",
                id: 0
            },
            modelingName: null,
            pending: true
        }
    }
};
</script>